import { render, staticRenderFns } from "./BabyProgressBar.vue?vue&type=template&id=13be1b5c&scoped=true"
import script from "./BabyProgressBar.vue?vue&type=script&lang=js"
export * from "./BabyProgressBar.vue?vue&type=script&lang=js"
import style0 from "./BabyProgressBar.vue?vue&type=style&index=0&id=13be1b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be1b5c",
  null
  
)

export default component.exports